import PdfIcon from '../../../../assets/icons/icon-pdf-file.svg?react'
import css from './attachment.module.css'
import domUtils from '../../../../utils/dom.utils.ts'
import Image from '../../../Common/Image'
import timeUtils from '../../../../utils/time.utils.ts'
import filesUtils from '../../files.utils.ts'
import { CSSProperties } from 'react'

interface IProps {
  name: string
  url: string
  extension: string

  metadata?: {
    created: string
    size: number
  }
  onClick?: () => void

  previewStyle?: CSSProperties
  width?: number | string
  height?: number | string
}

const AttachmentFile = ({ name, url, extension, onClick, width, height, metadata, previewStyle }: IProps) => {
  const renderPreview = () => {
    if (extension.includes('image')) {
      return <Image wrapperClassname={css.imageWrapper} className={css.image} src={url} alt={name} />
    }

    if (extension.includes('pdf')) {
      return <PdfIcon width={width || 40} height={height || 40} />
    }

    return <div>{extension}</div>
  }

  const handleClick = () => {
    if (onClick) {
      return onClick()
    }

    domUtils.openLink(url)
  }

  return (
    <div className={css.container} title={name} onClick={handleClick} style={{ width, height }}>
      <div className={css.previewWrapper} style={previewStyle}>
        {renderPreview()}
      </div>
      <div className="flex-lines gap4" style={{ padding: '0 8px' }}>
        <p className="text-nm text-link line-clamp" style={{ textDecoration: 'none' }}>
          {name}
        </p>
        {metadata && (
          <div className="inline-flex-gap gap16 flex-space-between">
            <p className="text-sm text-secondary">{timeUtils.formatDate(metadata.created, 'dd.MM.yyyy HH:mm')}</p>
            <p className="text-sm text-secondary">{filesUtils.humanFileSize(metadata.size)}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default AttachmentFile
